/**
 * Grip Kit cart guard
 *
 * Treat Box family products (Shopify tag `GripKit`) are kitted at and shipped
 * only from Grip NJ, so they must check out on their own. The product pages
 * already send GripKit buyers straight to checkout (snippets/grip-kit-checkout),
 * but a box can still reach the cart next to other lines (quick view from a
 * collection, coming back from checkout, ...).
 *
 * snippets/grip-kit-cart-guard.liquid renders `[data-grip-kit-cart-guard]`
 * with the keys of every non-GripKit line whenever a GripKit box is in the
 * cart. This script removes those lines as soon as that marker shows up, and
 * holds the checkout submit until the cart is clean.
 */
(function () {
  if (window.__wgGripKitCartGuard) return;
  window.__wgGripKitCartGuard = true;

  let inFlight = false;
  let noticePending = false;

  const guardEl = () => document.querySelector('[data-grip-kit-cart-guard]');
  const keysToRemove = (el) =>
    (el.getAttribute('data-remove-keys') || '')
      .split(',')
      .map((k) => k.trim())
      .filter(Boolean);

  function sectionsToBundle() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  function showNoticeIfPending(el) {
    if (!noticePending) return;
    noticePending = false;
    const tpl = document.querySelector('template[data-grip-kit-notice]');
    if (tpl && el && !el.parentNode.querySelector('.grip-kit-cart-guard__notice')) {
      el.insertAdjacentHTML('beforebegin', tpl.innerHTML);
    }
  }

  async function enforce() {
    const el = guardEl();
    if (!el || inFlight) return false;

    const keys = keysToRemove(el);
    if (!keys.length) {
      showNoticeIfPending(el);
      return false;
    }

    inFlight = true;
    try {
      const updates = {};
      keys.forEach((key) => { updates[key] = 0; });
      const sections = sectionsToBundle();

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections })
      });
      const cart = await response.json();
      noticePending = true;

      if (cart && cart.sections && window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      } else if (document.querySelector('cart-drawer')) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      } else {
        window.location.reload();
      }
      return true;
    } catch (error) {
      console.warn('[GripKitCartGuard] could not clean cart:', error);
      return false;
    } finally {
      inFlight = false;
    }
  }

  let timer = null;
  const scheduleEnforce = () => {
    clearTimeout(timer);
    timer = setTimeout(enforce, 60);
  };

  function init() {
    const targets = document.querySelectorAll('cart-drawer, main-cart, .cart');
    (targets.length ? targets : [document.body]).forEach((target) => {
      new MutationObserver(scheduleEnforce).observe(target, { childList: true, subtree: true });
    });
    scheduleEnforce();
  }

  // Hold the checkout submit until the stray lines are gone.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart(\?|$)/.test(form.getAttribute('action') || '')) return;
      const el = guardEl();
      if (!el || !keysToRemove(el).length) return;
      event.preventDefault();
      enforce().finally(() => { window.location.href = window.wgCheckoutUrl ? window.wgCheckoutUrl('/checkout') : '/checkout'; });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
